export default "__VITE_ASSET__CERGYxE5__";